'use client';

import type { FC } from 'react';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

export interface SwitchProps {
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

export const Switch: FC<SwitchProps> = forwardRef<HTMLInputElement, SwitchProps>(
  ({ checked, defaultChecked, disabled, onChange, className }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked);
    };

    return (
      <label className={cn('relative inline-block w-11 h-7 cursor-pointer', className)}>
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
          onChange={handleChange}
          className="peer opacity-0 w-0 h-0"
        />
        <span
          className={cn(
            'absolute cursor-pointer inset-0 bg-[#ccc] transition-all duration-[0.4s] rounded-full',
            'before:absolute before:content-[\'\'] before:h-5 before:w-5 before:left-1 before:bottom-1 before:bg-white before:transition-all before:duration-[0.4s] before:rounded-full',
            'peer-checked:bg-blue-500 peer-focus:shadow-[0_0_1px_#3b82f6] peer-checked:before:translate-x-4 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed',
          )}
        />
      </label>
    );
  },
);

Switch.displayName = 'Switch';
